document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ja-productpage-faqs-item__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const parent = this.closest(".ja-productpage-faqs-item");
      
      if (parent.classList.contains("show")) {
        parent.classList.remove("show");
      } else {
        parent.classList.add("show");
      }
    });
  });
});